import { all, takeLatest } from 'redux-saga/effects';

import { contactUsSaga } from './contactUsSaga';
import { contactUsRequest } from './layout-slice';

export default function* layoutSaga() {
  yield all([takeLatest(contactUsRequest, contactUsSaga)]);
}
